export const translations = {
  ar: [
    'أنشئ التعليق الصوتي لمقاطع فيديو يوتيوب، والإعلانات، والتدريب المؤسسي، والكتب الصوتية، والدبلجة، أو أي حالة استخدام تحتاجها.',
  ],
  da: [
    'Opret voice overs til Youtube-videoer, annoncer, virksomhedstræning, lydbøger, dubbing eller enhver brugssag, du har brug for.',
  ],
  nl: [
    "Maak voice-overs voor YouTube-video's, advertenties, bedrijfstrainingen, audioboeken, nasynchronisatie of andere toepassingen.",
  ],
  en: [
    'Create voice overs for Youtube videos, ads, corporate training, audiobooks, dubbing, or any use case you need.',
  ],
  et: [
    "Looge hääljuhiseid Youtube'i videote, reklaamide, ettevõtte koolituste, heliraamatute, dubleerimise või mis tahes vajaliku kasutusjuhtumi jaoks.",
  ],
  fi: [
    'Luo selostuksia Youtube-videoille, mainoksille, yrityskoulutukselle, äänikirjoille, jälkiäänitykselle tai mihin tahansa tarvitsemaasi käyttötapaukseen.',
  ],
  fr: [
    "Créez des voix off pour des vidéos YouTube, des publicités, des formations en entreprise, des livres audio, du doublage ou tout autre cas d'utilisation dont vous avez besoin.",
  ],
  de: [
    'Erstellen Sie Voice-Overs für YouTube-Videos, Anzeigen, Unternehmensschulungen, Hörbücher, Synchronisationen oder jeden anderen Anwendungsfall, den Sie benötigen.',
  ],
  el: [
    'Δημιουργήστε φωνητικά μηνύματα για βίντεο YouTube, διαφημίσεις, εταιρική εκπαίδευση, ηχητικά βιβλία, μεταγλώττιση ή οποιαδήποτε περίπτωση χρήσης χρειάζεστε.',
  ],
  he: [
    'צור קולות לסרטוני YouTube, מודעות, הדרכה ארגונית, ספרי אודיו, דיבוב או כל מקרה שימוש שאתה צריך.',
  ],
  hi: [
    'यूट्यूब वीडियो, विज्ञापन, कॉर्पोरेट प्रशिक्षण, ऑडियोबुक, डबिंग या किसी भी अन्य उपयोग के लिए वॉयस ओवर बनाएं।',
  ],
  it: [
    "Crea voci fuori campo per video di YouTube, pubblicità, corsi di formazione aziendale, audiolibri, doppiaggio o qualsiasi altro caso d'uso di cui hai bisogno.",
  ],
  pl: [
    'Twórz nagrania głosowe do filmów na YouTube, reklam, szkoleń korporacyjnych, audiobooków, dubbingu i innych zastosowań, których potrzebujesz.',
  ],
  pt: [
    'Crie locuções para vídeos do YouTube, anúncios, treinamentos corporativos, audiolivros, dublagem ou qualquer caso de uso que você precisar.',
  ],
  ru: [
    'Создавайте закадровый голос для видеороликов YouTube, рекламы, корпоративного обучения, аудиокниг, дубляжа или любых других вариантов использования.',
  ],
  es: [
    'Cree voces en off para videos de YouTube, anuncios, capacitaciones corporativas, audiolibros, doblajes o cualquier caso de uso que necesite.',
  ],
  sv: [
    'Skapa voice overs för Youtube-videor, annonser, företagsutbildning, ljudböcker, dubbning eller alla användningsfall du behöver.',
  ],
  tr: [
    'Youtube videoları, reklamlar, kurumsal eğitimler, sesli kitaplar, dublaj veya ihtiyacınız olan herhangi bir kullanım alanı için seslendirme oluşturun.',
  ],
  uk: [
    'Створюйте голос за кадром для відео YouTube, реклами, корпоративних тренінгів, аудіокниг, дубляжу чи будь-якого іншого використання, яке вам потрібно.',
  ],
  vi: [
    'Tạo giọng lồng tiếng cho video Youtube, quảng cáo, đào tạo doanh nghiệp, sách nói, lồng tiếng hoặc bất kỳ trường hợp sử dụng nào bạn cần.',
  ],
};
